// extracted by mini-css-extract-plugin
export default {"main":"ModalValoracionPrueba_main__WBaVG","intro":"ModalValoracionPrueba_intro__RNkiD","input":"ModalValoracionPrueba_input__nsUwn"};